import { TIMER } from "..";
import { Status } from "../visura.slice";
import { ToastContainer } from "react-toastify";

function VisuraToastContainerRendering({ status, onApiSuccess, onApiError }) {
  if (status === Status.SUCCESS) onApiSuccess();
  if (status === Status.ERROR) onApiError();
  return (
    <ToastContainer
      position="top-right"
      autoClose={TIMER}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
}

export default VisuraToastContainerRendering;
